import {
  ChatUserRoleDto
} from '../../apis/nhe-ai-chat-service/nhe-ai-chat-service.dtos';
import {
  getPromptExampleConfigsForRole,
  PromptExampleConfig
} from './example-prompts.constants';

export const getPromptExampleConfigsForCurrentChat = (userRole: ChatUserRoleDto): PromptExampleConfig[] => {
  const effectiveUserRole = userRole === ChatUserRoleDto.INSTRUCTOR_AS_STUDENT ? ChatUserRoleDto.STUDENT : userRole;
  return getPromptExampleConfigsForRole(effectiveUserRole);
};
